export default {"src":"/manage-assets/_next/static/media/personalized-demo-light.f739b101.svg","height":173,"width":272,"blurWidth":0,"blurHeight":0};